import { UserTypes } from './user.types';

export const addLocation = location => {
  return {
    "type": UserTypes.ADD_LOCATION,
    "payload": location
  };
};

export const setAlertMessage = message => {
  return {
    "type": UserTypes.SET_ALERT_MESSAGE,
    "payload": message
  };
};

export const setOverlayIsVisible = isVisible => {
  return {
    "type": UserTypes.SET_LOADING,
    "payload": isVisible
  };
};

export const resetInteractiveMap = uniqueId => {
  return {
    "type": UserTypes.RESET_MAP,
    "payload": uniqueId
  };
};

export const setWindToggleActive = isActive => {
  return {
    "type": UserTypes.SET_WIND_TOGGLE_TYPE,
    "payload": isActive
  };
};

export const setPollutantPopupType = popupTypeId => {
  return {
    "type": UserTypes.SET_POLLUTANT_POPUP_TYPE,
    "payload": popupTypeId
  };
};

export const setReloadStaticData = boolean => {
  return {
    "type": UserTypes.SET_RELOAD_STATIC_DATA,
    "payload": boolean
  };
};
